/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, SxProps, Theme } from "@mui/material";

export type FooterBackgroundImageProps = {
  sx?: SxProps<Theme>
}

export default function FooterBackgroundImage({ sx }: FooterBackgroundImageProps) {
  return (
    <Box
      sx={sx}
      component={"svg"}
      width="1047"
      height="1047"
      viewBox="0 0 1047 1047"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path="url(#clip0_1572_17300)">
        <g opacity="0.1">
          <path
            d="M1220.85 1066.08C1285.64 846.779 1333.51 734.011 927.195 487.606C520.88 241.096 479.345 -92.2208 479.345 -92.2208C477.58 429.976 762.198 521.561 949.001 788.526C1052.21 936.078 1009.54 1107.41 990.12 1166.08C1049.31 914.792 814.116 753.429 814.116 753.429C483.187 482.518 444.352 284.812 444.352 284.812C383.088 632.355 676.117 808.982 761.367 896.828C957.204 1072.42 961.98 1176.88 962.396 1175.63C974.129 1250.71 955.542 1291.2 948.793 1326.3C914.423 1175.94 781.615 1078.65 713.913 1011.67C570.826 870.246 458.889 702.86 458.889 702.86C424.519 1038.88 738.107 1175.32 854.093 1298.37C915.461 1363.47 922.107 1483.92 923.768 1534.49C924.599 1545.5 925.533 1583.61 925.845 1598.04C911.412 1482.26 870.084 1423.59 730.423 1322.98C587.855 1220.38 523.372 1135.96 523.372 1135.96C566.257 1412.07 705.606 1476.34 810.066 1541.35C914.527 1606.35 933.01 1701.88 933.01 1701.88C933.01 1700.94 933.01 1700.11 932.906 1699.18C938.721 1749.75 947.339 1797.1 958.138 1840.81C908.608 1781.31 850.875 1748.6 819.1 1726.18C739.042 1669.58 624.613 1563.77 624.613 1563.77C720.351 1860.75 1030.82 2119.2 1125.21 2205.7C1134.04 2215.25 1143.9 2224.28 1143.9 2224.28C1141.83 2220.44 1138.71 2212.55 1135.49 2207.05C955.75 1841.75 1175.78 1219.03 1220.85 1066.08Z"
            fill="white"
          />
          <path
            d="M2616.39 2350.05C2616.39 2350.05 2578.7 2116.42 2112.26 2227.63C2112.26 2227.63 1482.18 2303.43 1484.05 1911.86C1484.05 1911.86 1496.51 1210.02 1552.58 789.378C1608.55 368.734 940.875 343.917 495.31 -260C495.31 -260 343.708 148.599 928.622 527.293C1197.35 701.324 1419.05 787.717 1382.39 896.538C1223.21 1367.75 1179.7 1808.23 1179.7 1808.23C1179.7 1808.23 1111.27 2296.16 1530.46 2384.21V2384.42C1097.46 2407.99 923.742 2544.85 890.41 2569.56C806.51 2635.19 680.763 2739.54 624.587 2828.84C624.587 2828.84 757.603 2741.31 1560.78 2607.77C2091.7 2510.48 2606.53 2411.21 2729.47 2592.93C2729.47 2592.93 2772.87 2445.48 2616.5 2350.15L2616.39 2350.05ZM2449.84 2337.28C2430.73 2339.77 2415.57 2331.88 2400.41 2321.5C2386.08 2311.63 2370.09 2305.09 2353.16 2301.04C2371.85 2303.12 2393.35 2291.07 2411.83 2287.96C2432.39 2284.63 2449.63 2291.59 2466.66 2302.39C2479.85 2310.7 2492.41 2325.96 2509.13 2326.06C2488.67 2325.86 2469.77 2334.48 2449.84 2337.18V2337.28Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1572_17300">
          <rect width="1047" height="1047" fill="white" />
        </clipPath>
      </defs>
    </Box>
  );
}
